import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const IdentificationMiddlewareCategory = { id: 14, name: 'Identification Middleware' };
export const identificationPrompt = defineFeature({
    type: FeatureType.String,
    propName: 'identification_prompt',
    uiName: 'identificationPrompt',
    displayName: 'Identification Prompt',
    description: 'Prompt identifier used to detect query entities and rewrite the user query before orchestration.',
    category: IdentificationMiddlewareCategory,
    areas: ['agent'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    editor: 'prompt-select',
    surfacedIn: ['agent'],
});
export const identificationMiddlewareFeatures = [identificationPrompt];
